import { Text, Button } from "@ui-component-library";
import { useNavigationStore } from "../../store/NavigationStore";
import { cn } from "@utils/cn";

export default function SectionBadDataBanner({className}) {
  const { setView } = useNavigationStore()

  return <div className={cn("py-4 px-4 w-full mx-auto", className)}>
  <div className="flex flex-wrap gap-2 items-start md:items-center lg:items-center bg-cloud-200 border border-[#E6E6E6] border-solid rounded-xl p-4 justify-between">
    <div className="flex flex-col gap-2 lg:flex-row">
      <div className="flex flex-wrap gap-1">
        <Text variant="text-sm/leading-normal/bold" className="text-danger-500">
          Varning!
        </Text>
        <Text
          variant="text-sm/leading-normal/normal"
          className="text-charcoal-400"
        >
          Vissa avdelningar i denna fastighet innehåller avvikande data som kan påverka informationen nedan.
        </Text>
      </div>
    </div>

    <Button
      onClick={() => {setView({comp:"karta", hideSections:true, hideMarkers:true})}}
    >
      Visa i karta
    </Button>
  </div>
  </div>
}
